export const focalPointsTable = {
  Center: '50% 50%',
  'Upper Left': '25% 25%',
  'Upper Center': '50% 25%',
  'Upper Right': '75% 25%',
  'Lower Left': '25% 75%',
  'Lower Center': '50% 75%',
  'Lower Right': '75% 75%',
}
